import { call, put, takeLatest } from "redux-saga/effects";
import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";
import {
  PickupRequestDashboardActionTypes,
  PickupRequestDashboardActions,
} from "../../../actionTypes/operations/pickupRequestDashboradTypes";
import { getDashboardPickupRequestListApi } from "../../requests/operations/pickupRequestDashboardRequests";
import { setDashboardPickupRequestList, setDashboardPickupRequestListCount } from "../../../actions/operations/pickupRequestDashboardAction";

function* getDashboardPickupRequestListHandler(action: PickupRequestDashboardActionTypes) {
  // yield delay(500);
  try {
    yield startLoader("transparent");
    const { data } = yield call(getDashboardPickupRequestListApi, action.payload);
    if (data.status) {
      const fallBackData = [
        {
          id: 0,
          customer_id: 0,
          warehouse_id: 0,
          assigned_branch: "-",
          assigned_franchise: null,
          pickup_date: "-",
          pickup_time: '{"start_time":"00:00","close_time":"00:00"}',
          contact_person: "-",
          contact_number: "-",
          total_weight: 0,
          total_pcs: 0,
          package_type: "-",
          remarks: null,
          is_recurring: true,
          recurring_days: '[]',
          status: "-",
          awb_number: null,
          request_id: "-",
          createdAt: "0000-00-00T00:00:00.000Z",
          updatedAt: "0000-00-00T00:00:00.000Z",
          created_by: 0,
          warehouse: {
            id: 0,
            warehouse_name: "-",
            pickup_address: "-",
            return_address: "-",
          },
          branch: {
            id: 0,
            branch_name: "-",
          },
          franchise: {
            id: 0,
            franchise_name: "-"
          },
        },
      ];
      yield put(setDashboardPickupRequestList(data?.data?.rows || fallBackData));
      yield put(setDashboardPickupRequestListCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

// mode sagas
export default function* dashboardPickupRequestSaga() {
  yield takeLatest(PickupRequestDashboardActions.GET_PICKUP_REQUEST_DASHBOARD_LIST, getDashboardPickupRequestListHandler);
}
